export enum SelectionTypeEnum {
  Selection = 0,
  FixedSelection = 1,
}
